import { render, staticRenderFns } from "./BlogContent.vue?vue&type=template&id=764a118a&scoped=true&"
import script from "./BlogContent.vue?vue&type=script&lang=js&"
export * from "./BlogContent.vue?vue&type=script&lang=js&"
import style0 from "./BlogContent.vue?vue&type=style&index=0&id=764a118a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a118a",
  null
  
)

export default component.exports